export default __webpack_public_path__ + "static/media/Throwing Axe of the Ziggurat.b2cf2cd9.jpg";